import { Injectable } from '@angular/core';
import {FormatOptions} from './interfaces/format-service.interface';
import {NumericFormatUtilsService} from './numeric-format-utils.service';

@Injectable()
export class CurrencyFormatService {

  constructor(private numericFormatUtilsService: NumericFormatUtilsService) { }

  formatData(data: string | number, formatOptions: Partial<FormatOptions>) {
    let formatData;
    formatData = this.numericFormatUtilsService.formatDecimalPoint(data, formatOptions.decimalPointNumber,
      formatOptions.autoToFixed);
    formatData = this.numericFormatUtilsService.formatSeparator(formatData, formatOptions.hasSeparator);
    formatData = this.numericFormatUtilsService.formatMinus(formatData, formatOptions.formatType,
        formatOptions.negativeNumberFormat);
    if (!isNaN(+data)) {
      formatData = this.numericFormatUtilsService.addUnitSign(formatData, formatOptions.unit, formatOptions.maxValue);
    }
    formatData = formatOptions.currencyType === 'Rial' ? 'IRR' + formatData : '$' + formatData;

    return formatData;
  }
}
